function getLocation(state) {
    return state.location;
}

function getPrice(state) {
    return state.price;
}

function getFeatures(state) {
    return state.features;
}

function getServices(state) {
    return state.services;
}

function getFeatureOptions(state) {
    return state.featureOptions;
}

function getRanges(state) {
    return state.ranges;
}

function getCategory(state) {
    return state.category;
}

function getExtraContent(state) {
    return state.extraContent;
}

function getLocationTemp(state) {
    return state.locationTemp;
}

function getPriceTemp(state) {
    return state.priceTemp;
}

function getFeaturesTemp(state) {
    return state.featuresTemp;
}

function getServicesTemp(state) {
    return state.servicesTemp;
}

function getCategoryTemp(state) {
    return state.categoryTemp;
}

function getExtraContentTemp(state) {
    return state.extraContentTemp;
}

function getSearchDoneFromHome(state) {
    return state.searchDoneFromHome;
}

function getPreFetchedUser(state) {
    return state.preFetchedUser;
}

function getIsSeekingServicesProfile(state) {
    return state.isSeekingServicesProfile;
}

function getCmsContent(state) {
    return state.cmsContent;
}

function getAllServices(state) {
    return state.allServices;
}

function getTopServices(state) {
    return state.topServices;
}

function getSearchScrollPosition(state) {
    return state.searchScrollPosition;
}

function getSearchRadius(state) {
    return state.searchRadius;
}

function getSearchRadiusTemp(state) {
    return state.searchRadiusTemp;
}

function getIs404View(state) {
    return state.is404View;
}

function getTranslate(state) {
    return state.translate;
}

function getSimilarEscorts(state) {
    return state.similarEscorts;
}

function getSavedSearchNewEscorts(state) {
    return state.savedSearchNewEscorts;
}

function getShouldReloadConversations(state) {
    return state.shouldReloadConversations;
}

function getConversationUnreadMessageCount(state) {
    return state.conversationUnreadMessageCount;
}

function getSelectedConversation(state) {
    return state.selectedConversation;
}

function getUserProfileViewsNotificationCount(state) {
    return state.userProfileViewsNotificationCount;
}

function getVenue(state) {
    return state.venue;
}

function getAsia(state) {
    return state.asia;
}

function getLocale(state) {
    return state.locale;
}

function getCurrentUser(state) {
    return state.currentUser;
}

function getPageChanges(state) {
    return state.pageChanges;
}

export default {
    getLocation,
    getPrice,
    getFeatures,
    getServices,
    getCategory,
    getExtraContent,
    getLocationTemp,
    getPriceTemp,
    getFeaturesTemp,
    getServicesTemp,
    getCategoryTemp,
    getExtraContentTemp,
    getSearchDoneFromHome,
    getPreFetchedUser,
    getAllServices,
    getSearchScrollPosition,
    getTopServices,
    getSearchRadius,
    getSearchRadiusTemp,
    getIs404View,
    getTranslate,
    getSimilarEscorts,
    getCmsContent,
    getIsSeekingServicesProfile,
    getShouldReloadConversations,
    getConversationUnreadMessageCount,
    getSelectedConversation,
    getUserProfileViewsNotificationCount,
    getFeatureOptions,
    getRanges,
    getSavedSearchNewEscorts,
    getVenue,
    getAsia,
    getLocale,
    getCurrentUser,
    getPageChanges,
}
